module.exports = __webpack_public_path__ + "static/7-Dish w_loose flower sculpture-bd1d57a07ecfcf6e00cc39b8ad7777e7.jpg";